import React from 'react';
import { autobind } from 'core-decorators';
import { Row, Col } from 'src/componentes/grid';
import Dialog from 'src/componentes/dialog';
import Button from 'src/componentes/button';
import { FormattedMessage, injectIntl } from 'react-intl';
import Lookup from 'src/componentes/select2';
import Input from 'src/componentes/input';

import SmartVariableCalculationSelector from '../shared/SmartVariableCalculationSelector';
import ItemLookup from 'src/lookups/item';
import FormulaPreview from '../shared/FormulaPreview';

@autobind
class ConditionalFunctionModal extends React.Component {
  static defaultProps = {
    isOpen: false,
    titulo: 'Função Condicional',
    // Props de contexto para o SmartVariableCalculationSelector
    isItem: true,
    tipoItem: null,
    tipoEntidade: null,
    isCestaIndicadores: false,
    modulosPermitidos: [],
    hasLift: false,
    hasScore: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      seVariavel: this.getDefaultVariavel(),
      seItem: null,
      seValor: '',
      seUsarValor: false,
      operador: '>',
      itemVariavel: this.getDefaultVariavel(),
      comparacaoItem: null,
      itemValor: '',
      itemUsarValor: false,
      entao: '',
      senao: '',
      showValidation: false,
    };
  }

  componentDidUpdate(prevProps) {
    // Quando abrir novamente o modal, reseta o estado
    if (!prevProps.isOpen && this.props.isOpen) {
      this.setState({
        seVariavel: this.getDefaultVariavel(),
        seItem: null,
        seValor: '',
        seUsarValor: false,
        operador: '>',
        itemVariavel: this.getDefaultVariavel(),
        comparacaoItem: null,
        itemValor: '',
        itemUsarValor: false,
        entao: '',
        senao: '',
        showValidation: false,
      });
    }
  }

  getDefaultVariavel() {
    // Retorna Meta como padrão (será validado pelo SmartVariableCalculationSelector)
    return { id: 'Meta', descricao: 'Meta' };
  }

  getOperadorOptions() {
    return [
      { id: '>', descricao: '>' },
      { id: '<', descricao: '<' },
      { id: '=', descricao: '=' },
      { id: '>=', descricao: '>=' },
      { id: '<=', descricao: '<=' },
      { id: '!=', descricao: '!=' },
    ];
  }

  variavelRequerItem(variavelId) {
    if (variavelId === 'Valor') return false;
    
    const variaveisSemItem = [
      'ScoreFuncao', 'ScoreCategoria', 'PontosPorFaixaTransformada',
      'ScoreHierarquiaArea', 'ScoreHierarquiaColaborador', 'notaMetaIndividual'
    ];
    return !variaveisSemItem.includes(variavelId);
  }

  handleChangeSeVariavel(value) {
    this.setState({ 
      seVariavel: value,
      seUsarValor: value.id === 'Valor',
      seItem: value.id === 'Valor' ? null : this.state.seItem
    });
  }

  handleChangeItemVariavel(value) {
    this.setState({ 
      itemVariavel: value,
      itemUsarValor: value.id === 'Valor',
      comparacaoItem: value.id === 'Valor' ? null : this.state.comparacaoItem
    });
  }

  validateFields() {
    const { entao, senao } = this.state;
    return entao && senao;
  }

  buildExpression() {
    const { seVariavel, seItem, seValor, seUsarValor, operador, itemVariavel, comparacaoItem, itemValor, itemUsarValor, entao, senao } = this.state;

    // Verificar se todos os campos necessários estão preenchidos
    if (!entao || !senao) return '';

    // Construir lado esquerdo da condição
    let ladoEsquerdo = '';
    if (seUsarValor) {
      if (!seValor) return '';
      ladoEsquerdo = seValor;
    } else {
      if (this.variavelRequerItem(seVariavel.id) && !seItem) return '';
      ladoEsquerdo = this.variavelRequerItem(seVariavel.id) 
        ? `${seVariavel.id}([${seItem.idIntegracao}])`
        : `${seVariavel.id}()`;
    }

    // Construir lado direito da condição
    let ladoDireito = '';
    if (itemUsarValor) {
      if (!itemValor) return '';
      ladoDireito = itemValor;
    } else {
      if (this.variavelRequerItem(itemVariavel.id) && !comparacaoItem) return '';
      ladoDireito = this.variavelRequerItem(itemVariavel.id) 
        ? `${itemVariavel.id}([${comparacaoItem.idIntegracao}])`
        : `${itemVariavel.id}()`;
    }

    return `Se(${ladoEsquerdo}${operador}${ladoDireito},${entao},${senao})`;
  }

  buildPreview() {
    const { seVariavel, seItem, seValor, seUsarValor, operador, itemVariavel, comparacaoItem, itemValor, itemUsarValor, entao, senao } = this.state;

    // Construir lado esquerdo da condição
    let ladoEsquerdo = '';
    if (seUsarValor) {
      ladoEsquerdo = seValor || 'valor';
    } else {
      if (this.variavelRequerItem(seVariavel.id)) {
        const idItem = seItem ? seItem.idIntegracao : 'item';
        ladoEsquerdo = `${seVariavel.id.toLowerCase()}([${idItem}])`;
      } else {
        ladoEsquerdo = `${seVariavel.id.toLowerCase()}()`;
      }
    }

    // Construir lado direito da condição
    let ladoDireito = '';
    if (itemUsarValor) {
      ladoDireito = itemValor || 'valor';
    } else {
      if (this.variavelRequerItem(itemVariavel.id)) {
        const idItem = comparacaoItem ? comparacaoItem.idIntegracao : 'item';
        ladoDireito = `${itemVariavel.id.toLowerCase()}([${idItem}])`;
      } else {
        ladoDireito = `${itemVariavel.id.toLowerCase()}()`;
      }
    }

    const entaoTexto = entao || 'entao';
    const senaoTexto = senao || 'senao';

    return `Se(${ladoEsquerdo}${operador}${ladoDireito},${entaoTexto},${senaoTexto})`;
  }

  handleInsert() {
    if (!this.validateFields()) {
      this.setState({ showValidation: true });
      return;
    }

    const expr = this.buildExpression();
    if (expr) {
      this.props.onInsert(expr);
    }
  }

  render() {
    const { 
      isOpen, 
      titulo, 
      onRequestClose,
      isItem,
      tipoItem,
      tipoEntidade,
      isCestaIndicadores,
      modulosPermitidos,
      hasLift,
      hasScore
    } = this.props;
    
    const { seVariavel, seItem, seValor, seUsarValor, operador, itemVariavel, comparacaoItem, itemValor, itemUsarValor, entao, senao, showValidation } = this.state;
    
    const actions = [
      <Button key="btn-add" type="primary" onClick={this.handleInsert}>
        <FormattedMessage id="label.inserir" />
      </Button>,
    ];

    const operadorOptions = this.getOperadorOptions();

    return (
      <Dialog
        isOpen={isOpen}
        title={titulo}
        width={800}
        height={500}
        actions={actions}
        onRequestClose={onRequestClose}
        padContent
        styleTitle={{ paddingBottom: 0, marginBottom: 0 }}
      >
        <p>
          <FormattedMessage id="configuraRegrasFuncaoCondicional" />
        </p>

        <div style={{ backgroundColor: '#f8f9fa', padding: '15px', borderRadius: '5px', marginBottom: '15px' }}>
          <Row className="mb-2 align-items-end">
            {/* Se - Variável */}
            <Col md={2}>
              <SmartVariableCalculationSelector
                isItem={isItem}
                tipoItem={tipoItem}
                tipoEntidade={tipoEntidade}
                isCestaIndicadores={isCestaIndicadores}
                modulosPermitidos={modulosPermitidos}
                hasLift={hasLift}
                hasScore={hasScore}
                includeValorOption={true}
                value={seVariavel}
                onChange={this.handleChangeSeVariavel}
                showLabel={true}
                labelProps={{ id: "label.se" }}
              />
            </Col>
            
            {/* Se - Item ou Valor */}
            <Col md={3}>
              {!seUsarValor && this.variavelRequerItem(seVariavel.id) ? (
                <ItemLookup
                  model={{
                    label: <FormattedMessage id="item" />,
                    value: seItem,
                    requestChange: (v) => this.setState({ seItem: v }),
                  }}
                  className="inline-block"
                />
              ) : seUsarValor ? (
                <Input
                  model={{
                    label: <FormattedMessage id="valor" />,
                    value: seValor,
                    requestChange: (v) => this.setState({ seValor: v }),
                  }}
                />
              ) : null}
            </Col>

            {/* Operador */}
            <Col md={2}>
              <Lookup
                clearable={false}
                labelKey="descricao"
                valueKey="id"
                options={operadorOptions}
                model={{
                  label: <FormattedMessage id="label.operador" />,
                  value: operadorOptions.find(o => o.id === operador),
                  requestChange: (v) => this.setState({ operador: v.id }),
                }}
              />
            </Col>

            {/* Item - Variável */}
            <Col md={2}>
              <SmartVariableCalculationSelector
                isItem={isItem}
                tipoItem={tipoItem}
                tipoEntidade={tipoEntidade}
                isCestaIndicadores={isCestaIndicadores}
                modulosPermitidos={modulosPermitidos}
                hasLift={hasLift}
                hasScore={hasScore}
                includeValorOption={true}
                value={itemVariavel}
                onChange={this.handleChangeItemVariavel}
                showLabel={false}
              />
            </Col>
            
            {/* Item - Item ou Valor */}
            <Col md={3}>
              {!itemUsarValor && this.variavelRequerItem(itemVariavel.id) ? (
                <ItemLookup
                  model={{
                    label: <FormattedMessage id="item" />,
                    value: comparacaoItem,
                    requestChange: (v) => this.setState({ comparacaoItem: v }),
                  }}
                  className="inline-block"
                />
              ) : itemUsarValor ? (
                <Input
                  model={{
                    label: <FormattedMessage id="valor" />,
                    value: itemValor,
                    requestChange: (v) => this.setState({ itemValor: v }),
                  }}
                />
              ) : null}
            </Col>
          </Row>

          <Row className="mb-2">
            {/* Entao */}
            <Col md={6}>
              <Input
                model={{
                  label: <FormattedMessage id="entaoCondicao" />,
                  value: entao,
                  requestChange: (v) => this.setState({ entao: v }),
                  errors: showValidation && !entao ? this.props.intl.formatMessage({ id: 'campoObrigatorio' }) : null,
                }}
              />
            </Col>

            {/* Senao */}
            <Col md={6}>
              <Input
                model={{
                  label: <FormattedMessage id="senaoCondicao" />,
                  value: senao,
                  requestChange: (v) => this.setState({ senao: v }),
                  errors: showValidation && !senao ? this.props.intl.formatMessage({ id: 'campoObrigatorio' }) : null,
                }}
              />
            </Col>
          </Row>
        </div>

        <h6 className="mt-3 mb-1">
          <FormattedMessage id="previaFuncao" />
        </h6>
        <FormulaPreview formula={this.buildPreview()} />
      </Dialog>
    );
  }
}

export default injectIntl(ConditionalFunctionModal); 